import { $host } from './index';
import { ENDPOINTS } from '../constants/endpoints';

// Service products (telecom) have no t_product_id, so the product is taken from the cart
// response itself. Matching by t_product_id is only a fallback for an older backend and
// never matches on an empty id, which used to show every service item as the same product.
export const toCartItem = (item, products) => {
  const cartProduct = item.denomination?.product;
  const tProductId = cartProduct?.t_product_id;
  const product =
    (cartProduct?.id && (products.find((p) => p.id === cartProduct.id) || cartProduct)) ||
    (tProductId != null ? products.find((p) => p.t_product_id === tProductId) : undefined);

  return {
    id: item.id,
    productId: product?.id,
    name: product?.name,
    name_lv: product?.name_lv,
    imgUrl: product?.imgUrl,
    quantity: item.quantity,
    denominationId: item.denomination.id,
    denominationName: item.denomination.name,
    denominationName_lv: item.denomination.name_lv,
    price: item.denomination.price,
    stock: item.denomination.stock
  };
};

export const getCart = () => async (dispatch) => {
  try {
    dispatch({ type: 'App/SET_ACTIVITY', payload: true });
    const { data } = await $host.get(ENDPOINTS.CART.INFO);
    const { data: productsResponse } = await $host.get(ENDPOINTS.PRODUCTS.LIST, {
      params: { limit: 100 }
    });
    const products = productsResponse.data;

    dispatch({
      type: 'Cart/SET',
      payload: data.map((item) => toCartItem(item, products))
    });
    return data;
  } catch (error) {
    console.log(error);
    throw error?.response?.data;
  } finally {
    dispatch({ type: 'App/SET_ACTIVITY', payload: false });
  }
};

export const getCartSummary = async (paymentType) => {
  try {
    const { data } = await $host.get(ENDPOINTS.CART.SUMMARY, { params: { paymentType } });
    return data;
  } catch (error) {
    console.log(error);
    throw error?.response?.data;
  }
};

export const addToCart = (product, denomination, quantity) => async (dispatch, getState) => {
  try {
    dispatch({ type: 'App/SET_ACTIVITY', payload: true });

    const state = getState();
    if (state.user.id) {
      await $host.post(ENDPOINTS.CART.ADD, {
        denominationId: denomination.id,
        quantity: quantity
      });
    }
    dispatch({
      type: 'Cart/ADD',
      payload: {
        ...product,
        id: denomination.id,
        quantity,
        productId: product.id,
        denominationName: denomination.name,
        denominationName_lv: denomination.name_lv,
        denominationId: denomination.id,
        price: denomination.price,
        stock: denomination.stock
      }
    });
  } catch (error) {
    console.log(error);
    throw error?.response?.data;
  } finally {
    dispatch({ type: 'App/SET_ACTIVITY', payload: false });
  }
};

export const deleteFromCart = (productId, denominationId) => async (dispatch, getState) => {
  try {
    const state = getState();
    if (state.user.id) {
      await $host.delete(ENDPOINTS.CART.DELETE, {
        params: { denominationId }
      });
    }
    dispatch({ type: 'Cart/REMOVE', payload: productId });
  } catch (error) {
    console.log(error);
    throw error?.response?.data;
  }
};

export const updateInCart =
  (productId, denominationId, quantity) => async (dispatch, getState) => {
    try {
      const state = getState();
      if (state.user.id) {
        await $host.patch(
          ENDPOINTS.CART.UPDATE,
          { quantity },
          { params: { denominationId } }
        );
      }
      dispatch({ type: 'Cart/SET_QUANTITY', payload: { id: productId, quantity } });
    } catch (error) {
      console.log(error);
      throw error?.response?.data;
    }
  };
